// MaxHeight.js
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class MaxHeight extends BaseOption {
  static userInterfaceComponent = {
    label: "Max Height",
    component: inspectorTools.AUTOCOMPLETE,
    props: {
      showAllResultsOnClick: true,
      items: [
        { value: "fixed", label: "Fixed", action: true },
        { value: "unset", label: "unset" },
      ],
      prefix: "Max H:",
      suffix: "px",
      itemValueKey: "value",
      itemLabelKey: "label",
      allowCustomValue: true,
      subtleValueVariants: ["unset"],
      placeholder: "Max Height",
    },
  };

  static defaultValue = "unset";
}
